module.exports = __webpack_public_path__ + "static/img/lunch.3143907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunch.png
// module id = f7u5
// module chunks = 1